export default function CarrierBankAccount() {

  return (
      <p>حساب های شرکت حمل</p>
  );
};